export class Configuration{
    accountWebComponentBaseUrl: string = "";
    unifiedheaderBaseUrl: string = "";
    profileWebComponentBaseUrl: string = "";
    profileComponentApiUrl: string = "";
    dwAcademyBaseUrl: string = "";
    docuwareBaseUrl: string = "";
    dwFooterBaseUrl: string = "";
    companyRelationsWebComponentBaseUrl: string = "";
    companyRelationsUserApiBaseUrl: string = "";
    loginRedirect: string = "";
    shouldRoute: boolean = false;
    postLogoutRedirect: string = "";
    logoutCheckIntervalMs: number = 6000;
    peopleTileBaseUrl: string = "";
    managePeopleBaseUrl: string = "";
    companyMasterDataApiUrl: string = "";
    companyMasterDataWebComponentUrl: string = "";
    removeMainCompanyFeatureEnabled: boolean = false;
    shouldShowPaymentMethods: boolean = false;
    shouldShowInvoices: boolean = false;
    paymentMethodsComponentBaseUrl: string = "";
    paymentMethodsApiUrl: string = "";
    myAccountLink: string = "";
    myBusinessLink: string = "";
    invoicesApiUrl: string = "";

    constructor(obj: Partial<Configuration>) {
        Object.assign(this, obj);
    }
}